module.exports = __webpack_public_path__ + "img/illuminatingBIM_uncheck.38eb7fb0.png";